<div class="calendar-container" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
  <input
    type="text"
    class="form-control"
    [class.cursor-not-allowed]="disabled"
    [class.opacity-60]="disabled"
    [placeholder]="placeholder"
    [value]="displayValue"
    [disabled]="disabled"
    (click)="openCalendar($event)"
    />
    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayOrigin]="trigger"
      [cdkConnectedOverlayOpen]="showCalendar"
      [cdkConnectedOverlayPositions]="overlayPositions"
      [cdkConnectedOverlayHasBackdrop]="true"
      cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
      (backdropClick)="showCalendar = false"
      (detach)="showCalendar = false"
      >
      <div class="calendar-popup">
        @if (!timeSelectionMode) {
          <app-nepali-datepicker
            [initialDate]="selectedDate"
            [minDate]="effectiveMinDateBS"
            [maxDate]="effectiveMaxDateBS"
            (dateSelected)="onDateSelected($event)"
          ></app-nepali-datepicker>
        }

        @if (timeSelectionMode) {
          <div class="p-4 min-w-[200px]">
            <div class="text-sm font-semibold text-text mb-3 text-center">
              Select Time
            </div>
            <input
              type="time"
              class="form-control mb-4 text-center"
              [(ngModel)]="selectedTime"
              [ngModelOptions]="{ standalone: true }"
              />
              <button class="w-full inline-flex justify-center items-center px-4 py-2 bg-primary text-white rounded-md font-semibold tracking-wide transition-all duration-250 hover:-translate-y-0.5 active:translate-y-0 shadow-xs"
                (click)="confirmTimeSelection()"
                >
                Apply Time
              </button>
              <button class="w-full inline-flex justify-center items-center px-4 py-2 mt-2 bg-transparent text-text-subtle border border-border rounded-md font-semibold tracking-wide transition-all duration-250 hover:bg-surface-alt hover:text-text hover:-translate-y-0.5 active:translate-y-0"
                (click)="timeSelectionMode = false"
                >
                Back
              </button>
            </div>
          }
        </div>
      </ng-template>
    </div>
